export class Block {
    index:number;
    partialFile:Blob;

    constructor(index:number, partialFile:File) {
        this.index = index;
        this.partialFile = partialFile;
    }
}